export const IS_SANDBOX = process.env.REACT_APP_SANDBOX;
export const EXTENSION_IDENTIFIER = process.env.REACT_APP_EXTENSION_IDENTIFIER;

export const API_KEY_API_NAME =
  process.env.REACT_APP_EXTENSION_IDENTIFIER + "__API_KEY";

export const ORG_ID_API_NAME =
  process.env.REACT_APP_EXTENSION_IDENTIFIER + "__Organization_ID";

export const Use_Login_User_Credential_API_NAME =
  process.env.REACT_APP_EXTENSION_IDENTIFIER + "__Use_Login_User_Credential";

export const Default_Authenticator_API_NAME =
  process.env.REACT_APP_EXTENSION_IDENTIFIER + "__Default_Authenticator";

export const Z_API_KEY_API_NAME =
  process.env.REACT_APP_EXTENSION_IDENTIFIER + "__ZAPI_Key";

export const DATA_CENTER_URL_API_NAME =
  process.env.REACT_APP_EXTENSION_IDENTIFIER + "__Data_Center_URL";

export const DATA_CENTER_API_NAME =
  process.env.REACT_APP_EXTENSION_IDENTIFIER + "__Data_Center";

export const ZUID_API_NAME =
  process.env.REACT_APP_EXTENSION_IDENTIFIER + "__ZUID";

export const HIDE_LOGO_API_NAME =
  process.env.REACT_APP_EXTENSION_IDENTIFIER + "__Hide_Logo";

export const DEFAULT_VIEW_API_NAME =
  process.env.REACT_APP_EXTENSION_IDENTIFIER + "__Default_View";
// list, grid, details

export const PAGE_SIZE_API_NAME =
  process.env.REACT_APP_EXTENSION_IDENTIFIER + "__Page_Size";
// 10, 15, 25, 50, 100

export const ADMIN_API_URL = process.env.REACT_APP_ADMIN_SERVER_URL;
export const SERVICE_API_URL = process.env.REACT_APP_API_SERVER_URL;
